import { Component, h, Event, EventEmitter, Prop } from '@stencil/core';
import { Customer } from '../../../globals/customer';
import { ReviewApplicationTranslation } from '../../../globals/translations';

@Component({
  tag: 'review-state',
  styleUrl: './state-styles/review-state.scss',
  shadow: false,
})
export class ReviewState {
  @Prop() customer: Customer;
  @Prop() translation: Partial<ReviewApplicationTranslation>;

  @Event() updateCustomer: EventEmitter<Partial<Customer>>;
  @Event() continueClick: EventEmitter;

  render() {
    const {
      email,
      phone,
      tosAgree,
      firstName,
      lastName,
      dateOfBirth,
      taxpayerId,
      address: {
        shipping,
        billing: { line1: billingLine1, line2: billingLine2, city: billingCity, state: billingState, zip: billingZip },
      },
      incomeInfo,
      bankInfo,
      cardInfo: { firstName: cardFirstName, lastName: cardLastName, cardNumber, cardType, cvv, expirationDate },
    } = this.customer;

    const reviewProps = {
      email,
      phone,
      tosAgree,
      firstName,
      lastName,
      dateOfBirth,
      taxpayerId,
      ...shipping,
      billingLine1,
      billingLine2,
      billingCity,
      billingState,
      billingZip,
      ...incomeInfo,
      ...bankInfo,
      cardFirstName,
      cardLastName,
      cardNumber,
      cardType,
      cvv,
      expirationDate,
      translation: this.translation,
    };

    return <pc-application-review {...reviewProps} />;
  }
}
